import SendIcon from '@mui/icons-material/Send';
import React, { Fragment } from 'react';
import { Col, Row } from 'react-bootstrap';
import CustomButton from '../Reusable/CustomButton';
import FormWrapper from '../Reusable/FormWrapper/FormWrapper.js';
import InputField from '../Reusable/InputField';
import TransferList from '../Reusable/TransferList/TransferList.js';

const UserDefaultForm = ({
  translations,
  state,
  errors,
  rolesHashMapList,
  rolesInitiallySelected,
  onChangeHandler,
  onSubmitHandler,
  isUserUpdateForm,
  passwordChangeSignal,
  setErrors,
  submitRef,
  onGeneratePassword,
  loadingPassword,
  transferRef,
}) => {
  const {
    Placeholders,
    TransferList: TransferListTranslation,
    Labels,
    Tooltips,
  } = translations || {};
  const emailColStyle = isUserUpdateForm && 'm-auto';

  return (
    <FormWrapper
      submitRef={submitRef}
      noValidate={true}
      onSubmit={onSubmitHandler}
    >
      {!passwordChangeSignal ? (
        <Fragment>
          <Row md={12}>
            <Col md={4}>
              <InputField
                id="firstName"
                name="firstName"
                placeholder={Placeholders.firstName}
                onChange={onChangeHandler}
                value={state.firstName}
                error={errors}
                errorsHandler={setErrors}
                required
              />
            </Col>
            <Col md={4}>
              <InputField
                id="lastName"
                name="lastName"
                placeholder={Placeholders.lastName}
                onChange={onChangeHandler}
                value={state.lastName}
                error={errors}
                errorsHandler={setErrors}
                required
              />
            </Col>
            <Col md={4} className={`${emailColStyle}`}>
              <InputField
                id="email"
                name="email"
                type="email"
                placeholder={Placeholders.email}
                onChange={onChangeHandler}
                value={state.email}
                error={errors}
                errorsHandler={setErrors}
                required
                inputPlaceholder={'email@email.com'}
              />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <InputField
                id="username"
                name="username"
                placeholder={Placeholders.username}
                onChange={onChangeHandler}
                value={state.username}
                error={errors}
                errorsHandler={setErrors}
                required
              />
            </Col>
            <Col md={4}>
              <InputField
                id="ipBrojImena"
                name="ipBrojImena"
                placeholder={Placeholders.ipBrojImena}
                onChange={onChangeHandler}
                value={state.ipBrojImena}
              />
            </Col>
            <Col md={4}>
              <InputField
                id="ipBaseNumber"
                name="ipBaseNumber"
                placeholder={Placeholders.ipBaseNumber}
                onChange={onChangeHandler}
                value={state.ipBaseNumber}
              />
            </Col>
          </Row>
          <Row className="mt-3">
            <TransferList
              ref={transferRef}
              name={'roles'}
              itemsToChoose={rolesHashMapList}
              itemsSelected={rolesInitiallySelected}
              labelTextProp={'roleName'}
              targetEqualityCriteria={'id'}
              error={errors}
              errorsHandler={setErrors}
              translations={TransferListTranslation}
              width={280}
            />
          </Row>
        </Fragment>
      ) : (
        <Row md={12} className={`align-items-center justify-content-center`}>
          <Col md={4} className="text-center">
            <CustomButton
              variant="contained"
              endIcon={<SendIcon />}
              onClick={onGeneratePassword}
              className="col-md-10 mt-2 default-btn-primary"
              label={Labels.generate}
              tooltipText={Tooltips.generatePassword}
              type="button"
            />
          </Col>
          <Col md={4}>
            <InputField
              id="password"
              name="password"
              type="password"
              passwordVisibility={true}
              placeholder={Placeholders.password}
              value={state.password}
              error={errors}
              errorsHandler={setErrors}
              required
              disabled
              loading={loadingPassword}
            />
          </Col>
        </Row>
      )}
    </FormWrapper>
  );
};

export default UserDefaultForm;
